import React from 'react';
import { VariableSizeList as List } from 'react-window';

// Components
import EmojiPopupRow from './emojiList/EmojiPopupRow';
import EmojiPopupMenu from './components/EmojiPopupMenu';
import EmojiPopupContentNoResults from './emojiList/EmojiPopupContentNoResults';
import EmojiPopupContentLoading from './emojiList/EmojiPopupContentLoading';

// Hooks
import useEmojiPopupData from './hooks/useEmojiPopupData';

// Utils
import { isTitleRow } from './emojiPopupUtil';

// Constants
import { DEFAULT_COLUMN_COUNT, EmojiPopupContentProps } from './emojiPopupConstants';
import { EmojisRowData } from '../emojiTypes';

import './DesktopEmojiPopupContent.scss';

const ROW_HEIGHT = 34;
const LAST_ROW_IN_SECTION_HEIGHT = 46;

const PICKER_EMOJI_LIST_GU = ((32 + 4) * DEFAULT_COLUMN_COUNT) / 10;
const PICKER_LIST_WIDTH_GU = PICKER_EMOJI_LIST_GU + 16 / 10;
const PICKER_LIST_HEIGHT_GU = 505 / 10;

const getRowHeight = (index: number, emojisRowData: EmojisRowData) => {
    const nextRow = emojisRowData[index + 1];

    return nextRow && isTitleRow(nextRow) ? LAST_ROW_IN_SECTION_HEIGHT : ROW_HEIGHT;
};

const DesktopEmojiPopupContent = ({
    gridSize,
    selectedEmojiIds,
    onSelectEmoji,
    closePopup,
}: EmojiPopupContentProps) => {
    const {
        currentCategory,
        setCurrentCategory,
        setSearchFilter,
        emojiData,
        emojiDataLoaded,
        emojisRowData,
        handleEmojiListScroll,
        listRef,
        getKeyOfItemAtIndex,
        getHeightOfItemAtIndex,
        handleClickEmoji,
        skinTone,
        dispatchUpdateSkinTone,
    } = useEmojiPopupData(onSelectEmoji, closePopup, getRowHeight);

    const pickerListWidth = PICKER_LIST_WIDTH_GU * gridSize;
    const pickerListHeight = PICKER_LIST_HEIGHT_GU * gridSize;

    return (
        <div className="DesktopEmojiPopupContent EmojiPopupContent">
            <EmojiPopupMenu
                emojiData={emojiData}
                skinTone={skinTone}
                currentCategory={currentCategory}
                setCurrentCategory={setCurrentCategory}
                setSearchFilter={setSearchFilter}
                emojisRowData={emojisRowData}
                listRef={listRef}
                dispatchUpdateSkinTone={dispatchUpdateSkinTone}
                gridSize={gridSize}
            />

            {emojiDataLoaded && emojisRowData.length ? (
                <List
                    className="emoji-list"
                    onScroll={handleEmojiListScroll}
                    ref={listRef}
                    width={pickerListWidth}
                    height={pickerListHeight}
                    itemCount={emojisRowData.length}
                    itemSize={getHeightOfItemAtIndex}
                    itemKey={getKeyOfItemAtIndex}
                    itemData={{
                        rows: emojisRowData,
                        skinTone,
                        selectedEmojiIds,
                        handleClickEmoji,
                        gridSize,
                    }}
                    overscanCount={10}
                >
                    {EmojiPopupRow}
                </List>
            ) : emojiDataLoaded ? (
                <EmojiPopupContentNoResults
                    style={{ width: pickerListWidth, height: pickerListHeight }}
                    gridSize={gridSize}
                />
            ) : (
                <EmojiPopupContentLoading style={{ width: pickerListWidth, height: pickerListHeight }} />
            )}
        </div>
    );
};

export default DesktopEmojiPopupContent;
